import { TranslatorContext } from '@jutro/locale';
import { useHistory } from 'react-router-dom';
import {
    useDataRefresh,
    ViewModelForm,
    ViewModelServiceContext,
} from '@xengage/gw-portals-viewmodel-react';

import _ from 'lodash';
import React, {
    useContext,
    useEffect,
    useState,
    useCallback,
    useMemo
} from 'react';
import { AgencyAdminService } from "twia-capability-agencyadmin";
import styles from '../../pages/Administration/Administration.module.scss'
import metadata from './EditPLA.metadata.json5';

function EditPLA(props) {
    const [editAddress, updateEditAddressVM] = useState();
    const [address, setAddress] = useState();
    // US26490 updateLocationAddress for submit function
    const {  tdiAddress, updatelocationAddress, userVM } = props;
    const history = useHistory();
    const { refreshData } = useDataRefresh();
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);



    useEffect(() => {

        const addressVM = viewModelService.create(
            {},
            'pc',
            'org.twia.elevate.edge.capabilities.agent.dto.TDIAgencyLookupDTO'
        );

        addressVM.agencyAddresses = viewModelService.create(
            {},
            'pc',
            'org.twia.elevate.edge.capabilities.agent.dto.TDIAgencyAddressDTO'
        );
        // DE15291 - Prefilling the address fields
        if(userVM){
            _.set(addressVM, 'agencyAddresses', userVM.organization_EXT.primaryLocationAddress_TWIA)
        }

        updateEditAddressVM(addressVM);
    }, []);
    

    const setAvailableAddressValue = useMemo(() => {
        const agencyAddress = tdiAddress?.map(key => ({
                    name: translator({
                        id: key.recordID,
                        defaultMessage: key.displayName,
                    }),
                    code: key.recordID
                }))

        return agencyAddress;
    }, [tdiAddress, translator]);

    const cancel = useCallback(() => {
        history.go('/administration');
    }, [history]);

    const submit = () => {
        updatelocationAddress(editAddress);
    };

 
    const handleValueChange = useCallback(
        (value) => {
            tdiAddress.some((element) => {

                if (element.recordID === value) {
                    _.set(editAddress, 'agencyAddresses', element)
                    
                    
                } 
            });
            updateEditAddressVM(editAddress);
        },
        [editAddress, tdiAddress]);
    
    const writeValue = useCallback(
        (value, path) => {
            _.set(editAddress, `${path}.value`, value);
            updateEditAddressVM(editAddress);
            refreshData();
        },
        [editAddress, refreshData]
    );

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            phoneWide: {
                labelPosition: 'top',
            },
        },

        plaAddress: {
            availableValues: setAvailableAddressValue,
            value: address,
            onValueChange: (value) => {setAddress(value); handleValueChange(value)}      
           
        },
    };


    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {

        },
        resolveCallbackMap: {
            handleValueChange: handleValueChange,
            clickCancel: cancel,
            clickSubmit: submit
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={editAddress}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
            onValueChange={writeValue}
        />
    );
}

EditPLA.propTypes = {

};

EditPLA.defaultProps = {

};

export default EditPLA;
